import {EventEmitter, Injectable, Output} from '@angular/core';
import {ConfService} from './conf.service';
import {environment} from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WorkflowListenerService {

  @Output() workflowListener: EventEmitter<any> = new EventEmitter();


  constructor() {
    this.workflowListener.subscribe(
        (eventObject) => {
          // This listener has to be removed
        }
    );
  }
}
